import {
  DURATION_KEY,
  PREVIEW_TAGS_KEY,
  PREVIEW_ALT_DURATION_KEY,
  PRICE_KEY,
  PRICE_ON_PEER_KEY,
  POINTS_KEY,
  E_SHOW_NEXT_CRUISE,
  PAGE_TITLE,
  ID_KEY,
  URI_KEY,
  PREVIEW_IMAGE_URI,
  CURRENCY_SIGN_KEY,
  getTagStylesFromTag,
} from '../../trips';
import styles from './Trip.module.scss';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { PriceBox } from '..';
import { NextTrips, SubmitButton, displayPrice } from '../../ui';
import { ReactComponent as Time } from '../../../assets/time.svg';
import { ReactComponent as CheckMark } from '../../../assets/check-mark.svg';

const cx = classNames.bind(styles);

interface TripProps {
  trip: { [key: string]: any };
  isDateSelected: boolean;
}

const { REACT_APP_PATHNAME } = process.env;
const resource = REACT_APP_PATHNAME?.split('//')[1] || 'nevatrip.ru';

export default function Trip({
  trip,
  isDateSelected,
}: Readonly<TripProps>): JSX.Element {
  const { t } = useTranslation();
  const ref = useRef<HTMLLIElement | null>(null);
  const [visible, setVisible] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '100px',
      }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, []);
  const getTripImageUrl = (): string => {
    if (trip[PREVIEW_IMAGE_URI]) {
      return `/${trip[PREVIEW_IMAGE_URI]}`;
    } else {
      return `/assets/img/e/${trip[URI_KEY]}.jpg`;
    }
  };

  const isTargetBlankTrip = (res: string) => {
    const localRes = document.location.href;

    if (res + '/' !== localRes) return '_blank';
    return '';
  };

  /**
   * Отправляет выбор тг боту.
   * @param trip_id ID экскурсии
   * @param resource домен прогулки
   */
  const tgBotBuy = (trip_id: number, resource: string) => {
    // Передача выбора телеграм боту
    if (window.hasOwnProperty('Telegram')) {
      const user_id = eval('Telegram.WebApp.initDataUnsafe.user.id;');

      fetch(
        '/ajax/bot/callback?trip_id=' +
          trip_id +
          '&resource=' +
          resource +
          '&method=trip_select&user_id=' +
          user_id
      ).then(() => {
        // ну таких костылей ты ещё не видел
        eval('window.Telegram.WebApp.close();');
      });
    } else {
      console.error('Telegram lib is missing!');
    }
  };

  const price = displayPrice(
    trip[PRICE_KEY],
    trip[CURRENCY_SIGN_KEY][0],
    trip[CURRENCY_SIGN_KEY][1]
  );

  let subPrice: string | undefined;

  if (trip[PRICE_ON_PEER_KEY] === 'не реализуется') {
    subPrice = trip[PRICE_ON_PEER_KEY] + '\u00a0' + t('at_the_pier');
  } else if (trip[PRICE_ON_PEER_KEY]?.includes('за группу')) {
    subPrice = trip[PRICE_ON_PEER_KEY];
  } else if (trip[PRICE_ON_PEER_KEY]) {
    subPrice =
      displayPrice(
        trip[PRICE_ON_PEER_KEY],
        trip[CURRENCY_SIGN_KEY][0],
        trip[CURRENCY_SIGN_KEY][1]
      ) +
      '\u00a0' +
      t('at_the_pier');
  }

  const isBot = window.hasOwnProperty('isTGBot');

  const excursionHref = `/${trip[URI_KEY]}`;

  return (
    <li
      ref={ref}
      className={styles.root}
    >
      <div className={styles.trip}>
        <a
          id={'filter_click_trip_id=' + trip[ID_KEY]}
          href={excursionHref}
          className={styles.preview}
          rel='nofollow'
        >
          {trip[PREVIEW_TAGS_KEY] && (
            <span
              className={styles.tag}
              style={{
                background: getTagStylesFromTag(trip[PREVIEW_TAGS_KEY])[2],
                color: getTagStylesFromTag(trip[PREVIEW_TAGS_KEY])[3],
              }}
            >
              {getTagStylesFromTag(trip[PREVIEW_TAGS_KEY])[1].toUpperCase()}
            </span>
          )}

          <img
            style={isImageLoaded ? {} : { display: 'none' }}
            src={visible ? getTripImageUrl() : ''}
            alt={trip[PAGE_TITLE]}
            onLoad={() => setIsImageLoaded(true)}
          />
          {/* TODO: сделать скелетон для картинок */}
          {!visible && null}
        </a>
        <div className={styles.description}>
          <a
            id={'filter_click_trip_id=' + trip[ID_KEY]}
            href={excursionHref}
            className={cx('title', resource.includes('busguide') && 'busguide')}
          >
            {trip[PAGE_TITLE]}
          </a>
          {trip[DURATION_KEY] && (
            <div className={styles.time}>
              <Time className={styles.timeIcon} />
              {trip[PREVIEW_ALT_DURATION_KEY] || trip[DURATION_KEY]}
            </div>
          )}

          <ul className={styles.list}>
            {trip[POINTS_KEY].split('\r\n').map((punkt: string, i: number) => {
              if (punkt)
                return (
                  <li
                    key={i}
                    className={cx(
                      'listItem',
                      resource.includes('busguide') && 'busguide'
                    )}
                  >
                    <CheckMark />
                    {punkt.trim()}
                  </li>
                );
            })}
            {/* DATE */}
            {Boolean(trip[E_SHOW_NEXT_CRUISE]) &&
              trip.next_trip?.closestDateDay && (
                <li
                  className={cx(
                    'listItem',
                    resource.includes('busguide') && 'busguide'
                  )}
                >
                  <CheckMark />
                  {trip.next_trip.closestDateDay && (
                    <>{!isDateSelected && t('next_trip') + ':\u00a0'}</>
                  )}
                  {isDateSelected
                    ? trip.next_trip.closestDateDay
                    : trip.next_trip.closestDateDay.toLowerCase()}
                  {trip.next_trip.times.length > 0 && (
                    <>
                      &nbsp;
                      <NextTrips
                        className={styles.nextTrips}
                        dateTimes={trip.next_trip.times}
                        tripId={trip[ID_KEY]}
                      />
                    </>
                  )}
                </li>
              )}
          </ul>
          <PriceBox
            className={styles.pricebox}
            price={price}
            subPrice={subPrice}
            button={
              <SubmitButton
                text={isBot ? t('buy') : t('more')}
                isButton={isBot}
                onClick={() => {
                  tgBotBuy(trip[ID_KEY], resource);
                }}
                id={'filter_click_trip_id=' + trip[ID_KEY]}
                href={excursionHref}
                className={isBot ? '' : `btn-buy-special-${resource}`}
                rel='nofollow'
              />
            }
          />
        </div>
      </div>
      <hr className='short' />
    </li>
  );
}
